/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
import { Flex } from '@chakra-ui/react'
import { DescricaoCargo } from '../../../../../interfaces'

interface Props {
  cargos: DescricaoCargo[]
}

export const GraficoMediaPorGrupo: React.FC<Props> = ({ cargos }) => {
  useEffect(() => {
    const grupos = {
      Produtivo: [] as number[],
      Administrativo: [] as number[],
      'Não gestores': [] as number[],
      Gestores: [] as number[]
    }

    cargos.forEach(cargo => {
      Object.entries(cargo.niveis).forEach(([nivelNome, nivel]) => {
        const colabs = cargo.colaboradores?.filter(c => c.nivel === nivelNome && c.salario) || []

        const mediaSalarial = colabs.reduce((acc, c) => acc + (c.salario ?? 0), 0) / (colabs.length || 1)
        const mediana = nivel.mediana

        if (!isNaN(mediaSalarial) && mediana > 0) {
          const percentual = Math.round((mediaSalarial / mediana) * 100)

          if (cargo.atuacao === 'Produtivo') grupos.Produtivo.push(percentual)
          if (cargo.atuacao === 'Administrativo') grupos.Administrativo.push(percentual)

          colabs.forEach(c => {
            if (c.tipoColaborador === 0) grupos.Gestores.push(percentual)
            else grupos['Não gestores'].push(percentual)
          })
        }
      })
    })

    const series = [
      {
        name: 'Média Salarial',
        data: [
          Math.round(grupos.Produtivo.reduce((a, b) => a + b, 0) / (grupos.Produtivo.length || 1)),
          Math.round(grupos.Administrativo.reduce((a, b) => a + b, 0) / (grupos.Administrativo.length || 1)),
          Math.round(grupos['Não gestores'].reduce((a, b) => a + b, 0) / (grupos['Não gestores'].length || 1)),
          Math.round(grupos.Gestores.reduce((a, b) => a + b, 0) / (grupos.Gestores.length || 1))
        ]
      }
    ]

    const options = {
      chart: {
        type: 'bar',
        height: 280
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '50%',
          dataLabels: {
            position: 'bottom' // Isso posiciona a % abaixo da barra
          }
        }
      },
      colors: ['var(--Azul)'],
      dataLabels: {
        enabled: true,
        formatter: (val: number) => `${val}%`,
        textAnchor: 'start',
        offsetX: 0,
        style: {
          fontWeight: 600
        }
      },
      xaxis: {
        categories: ['Produtivo', 'Administrativo', 'Não gestores', 'Gestores'],
        labels: {
          formatter: (val: string) => val
        }
      },
      yaxis: {
        labels: {
          style: {
            fontWeight: 600
          }
        },
        max: 120
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (val: number) => `${val}%`
        }
      },
      legend: {
        show: false
      }
    }

    const chart = new ApexCharts(document.querySelector('#grafico-media-grupo'), {
      ...options,
      series
    })
    chart.render()
  }, [cargos])

  return <Flex id="grafico-media-grupo" w="100%" />
}
